class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    // querySelectorAll (not querySelector) - a modal can have more than one
    // close button (e.g. a mobile-only header close button alongside the
    // default one), and only wiring the first match found in DOM order would
    // leave whichever one isn't first non-functional, even if it's the one
    // actually visible at the current breakpoint.
    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Shared with the mobile menu drawer (assets/global.js), which measures
    // this on its own open - refresh it here too so a fullscreen mobile
    // modal opened via this component (e.g. search) also starts exactly
    // where the header currently is, floating pill or not, even if the menu
    // drawer was never opened first.
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
      document.documentElement.style.setProperty(
        '--mobile-menu-drawer-top',
        `${parseInt(headerWrapper.getBoundingClientRect().bottom)}px`
      );
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
